import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import SupplierShape from './prop_shapes/supplier'
import { AuthContext, USER_TYPES, USER_STATES } from 'components/common/auth/AuthContext'

import Navigation from './Navigation'
import UploadCustomersCTABox from './UploadCustomersCTABox'
import ContactButton from './ContactButton'
import UnclaimedCTABox from './UnclaimedCTABox'
import ReviewCreateButton from './ReviewCreateButton'
import ListSelector from './ListSelector'
import UpgradeToPremiumCTABox from './UpgradeToPremiumCTABox'

const Sidebar = ({ supplier, shouldShowRecentPosts }) => {
  const authContext = useContext(AuthContext)

  const renderContactButton = () => {
    if (supplier.pro && supplier.contactMethod.contactConfigured) {
      const { pro, contactMethod, id } = supplier
      return (
        <div style={{ marginTop: '21px' }}>
          <ContactButton
            pro={pro}
            contactByEmail={contactMethod.contactByEmail}
            link={contactMethod.link}
            supplierId={id}
            contactConfigured={contactMethod.contactConfigured}
            trackingKey='supplier_sidebar_contact_button'
            className='expanded hide-for-medium-only'
            text='Contact Supplier'
          />
        </div>
      )
    }
  }

  const renderReviewButton = () => (
    <ReviewCreateButton
      className='hollow expanded hide-for-medium-only bottom-margin supplier-dashboard-review-cta-button'
      supplierId={supplier.id}
      text={
        ['Write a review for this supplier ', <i className='fas fa-edit' key='sidebar-review-btn' />]
      }
    />
  )

  const renderListsSelector = () => {
    return (
      <ListSelector supplier={supplier} />
    )
  }

  const renderSidebarCTA = (authContext, pro) => {
    if (!authContext.isOwner) {
      return null
    }

    if (pro) {
      return <UploadCustomersCTABox />
    } else {
      return <UpgradeToPremiumCTABox />
    }
  }

  return (
    <div data-sticky-container id='sidebar' data-testid='sidebar'>
      <div
        className='sticky'
        data-sticky
        data-margin-top='5'
        style={{ width: '100%' }}
        data-top-anchor='supplier-details:top'
        data-btm-anchor='grid-container:bottom'
      >
        <Navigation shouldShowRecentPosts={shouldShowRecentPosts} />
        {
          authContext.userType === USER_TYPES.AGENCY_USER && (
            <>
              {renderContactButton()}
              {renderReviewButton()}
              {authContext.userState === USER_STATES.VERIFIED && renderListsSelector()}
            </>
          )
        }
        {
          authContext.userType === USER_TYPES.SUPPLIER_USER && (
            <>
              {renderContactButton()}
              {renderSidebarCTA(authContext, supplier.pro)}
            </>
          )
        }
        {
          authContext.userType === USER_TYPES.UNAUTHED && (
            <>
              {renderContactButton()}
              {renderReviewButton()}
              {!supplier.claimed && <UnclaimedCTABox className='hide-for-medium-only' supplierId={supplier.id} />}
            </>
          )
        }
      </div>
    </div>
  )
}

Sidebar.propTypes = {
  supplier: SupplierShape,
  shouldShowRecentPosts: PropTypes.bool
}

Sidebar.defaultProps = {
  supplier: {},
  shouldShowRecentPosts: false
}

export default Sidebar
